import img1 from "../assets/gallery/India and Spain/india-and-spain1.jpg";
import img2 from "../assets/gallery/India and Spain/india-and-spain2.jpg";
import img3 from "../assets/gallery/India and Spain/india-and-spain3.jpg";
import img4 from "../assets/gallery/India and Spain/india-and-spain4.jpg";
import img5 from "../assets/gallery/India and Spain/india-and-spain5.jpg";
import img6 from "../assets/gallery/India and Spain/india-and-spain6.jpg";
import img7 from "../assets/gallery/India and Spain/india-and-spain7.jpg";
import img8 from "../assets/gallery/India and Spain/india-and-spain8.jpg";
import img9 from "../assets/gallery/India and Spain/india-and-spain9.jpg";
import img10 from "../assets/gallery/India and Spain/india-and-spain10.jpg";
import img11 from "../assets/gallery/India and Spain/india-and-spain11.jpg";
import img12 from "../assets/gallery/India and Spain/india-and-spain12.jpg";
import img13 from "../assets/gallery/India and Spain/india-and-spain13.jpg";
import img14 from "../assets/gallery/India and Spain/india-and-spain14.jpg";
import img15 from "../assets/gallery/India and Spain/india-and-spain15.jpg";
import img16 from "../assets/gallery/India and Spain/india-and-spain16.jpg";
import img17 from "../assets/gallery/India and Spain/india-and-spain17.jpg";
import img18 from "../assets/gallery/India and Spain/india-and-spain18.jpg";
import img19 from "../assets/gallery/India and Spain/india-and-spain19.jpg";
import img20 from "../assets/gallery/India and Spain/india-and-spain20.jpg";
import img21 from "../assets/gallery/India and Spain/india-and-spain21.jpg";
import img22 from "../assets/gallery/India and Spain/india-and-spain22.jpg";
import img23 from "../assets/gallery/India and Spain/india-and-spain23.jpg";
import img24 from "../assets/gallery/India and Spain/india-and-spain24.jpg";
import img25 from "../assets/gallery/India and Spain/india-and-spain25.jpg";
import img26 from "../assets/gallery/India and Spain/india-and-spain26.jpg";
import img27 from "../assets/gallery/India and Spain/india-and-spain27.jpg";

const indiaSpainGallery = [
  { img: img1, rowSpan: 2 },
  { img: img2 },
  { img: img3 },

  { img: img4 },
  { img: img5 },
  { img: img6, rowSpan: 2 },

  { img: img7, colSpan: 2 },

  { img: img8 },
  { img: img9, rowSpan: 2 },
  { img: img10 },

  { img: img11 },
  { img: img12 },
  { img: img13 },

  { img: img14, colSpan: 2 },
  { img: img15 },

  { img: img16 },
  { img: img17, rowSpan: 2 },
  { img: img18 },

  { img: img19, colSpan: 2 },

  { img: img20 },
  { img: img21 },
  { img: img22 },

  { img: img23, rowSpan: 2 },
  { img: img24 },
  { img: img25 },

  { img: img26, colSpan: 2 },
  { img: img27 },
];

export default indiaSpainGallery;
